// extracted by mini-css-extract-plugin
module.exports = {"formTop":"styles__formTop___J9tZr","uploadPhoto":"styles__uploadPhoto___1sKZ-","uploadPhotoIcon":"styles__uploadPhotoIcon___zxhxq"};